var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.gameState.inTravelModal
    ? _c(
        "div",
        { staticClass: "travel-modal", on: { click: _vm.closeModal } },
        [
          _c(
            "div",
            {
              staticClass: "travel-card",
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                },
              },
            },
            [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "travel-content" }, [
                _c(
                  "div",
                  { staticClass: "location-list" },
                  _vm._l(_vm.availableLocations, function (location) {
                    return _c(
                      "button",
                      {
                        key: location.name,
                        staticClass: "location-button",
                        class: {
                          "current-location-btn":
                            _vm.gameState.location === location.name,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.travelToLocation(location.name)
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "location-name" }, [
                          _vm._v(_vm._s(location.name)),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "location-description" }, [
                          _vm._v(_vm._s(location.description)),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "location-features" },
                          _vm._l(location.features, function (feature) {
                            return _c(
                              "div",
                              { key: feature, staticClass: "location-feature" },
                              [_vm._v(_vm._s(feature))]
                            )
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _vm.gameState.location === location.name
                          ? _c("div", { staticClass: "current-location" }, [
                              _vm._v("当前位置"),
                            ])
                          : _vm._e(),
                      ]
                    )
                  }),
                  0
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "travel-footer" }, [
                _c(
                  "button",
                  {
                    staticClass: "close-btn",
                    on: { click: _vm.handleCloseClick },
                  },
                  [_vm._v("关闭")]
                ),
              ]),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "travel-header" }, [
      _c("h3", [_vm._v("选择目的地")]),
      _vm._v(" "),
      _c("p", [_vm._v("选择你要前往的地点，每个地点都有不同的机遇和挑战。")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }